import React from 'react';
import personImage from '../../assets/sushma sengupta.jpg';

const AboutLegacy = () => {
  return (
    <section className="bg-bg-light px-6 py-14 md:px-12">
      <div className="mx-auto grid max-w-6xl items-center gap-10 md:grid-cols-2 md:gap-14">
        <div className="flex justify-center md:justify-start">
          <img
            src={personImage}
            alt="Dr. Sushma Sengupta, founder of Drishtikon"
            className="h-[520px] w-full max-w-md rounded-2xl object-cover shadow-lg"
          />
        </div>

        <div>
          <h2 className="mb-2 text-3xl font-bold uppercase text-accent md:text-4xl">
            Our Legacy
          </h2>
          <h3 className="mb-4 text-xl font-semibold text-primary md:text-2xl">
            Sushma Sengupta
          </h3>
          <p className="text-base leading-relaxed text-gray-700 md:text-lg">
          Dr. Sushma Sengupta - A woman with indomitable courage herself, she was just 
          12 years old when she had to move away from her native place Sandila, a very small 
          town in Uttar Pradesh, in order to pursue her education. At the age of 16, she joined 
          Agra Medical College, and pursued her studies in terribly tough circumstances. As her 
          family back home was in a terrible financial crisis, she saved and sent money from her stipend 
          home by cutting down on her food in hostel and having one meal a day. Over and above that, due 
          to lack of clothes, she managed by wearing one torn saree. Emerging as a winner through these 
          difficulties, she courageously joined the Indian Army. After she got married and had children, 
          she left the Army and lived for a long period as a homemaker. However, nothing could keep the fire 
          in her down, and in 1995, at the age of 57, she launched DRISHTIKON, an NGO in Delhi dedicated 
          towards health of women and children. She held the position of the Founder President for 28 years, 
          until age took over and she officially resigned at the age of 85, now living a peaceful life. Yet, her 
          journey of compassion is not over. As from where she quit, her son Saurabh Sengupta has taken 
          over, to spread her light, in the form of an independent project DRISHTIKON HIMMATWAALI MISSION.
          </p>
        </div>
      </div>
    </section>
  );
};
export default AboutLegacy;
